import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import { SignOut } from "@phosphor-icons/react";

const InactivePerfilModal = ({
	show,
	onDeleteClick,
	onCloseClick,
	nomePerfil,
}) => {
	return (
		<Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16 mb-4">
						Tem certeza de que deseja inativar o perfil?
					</p>
					<p className="text-muted font-size-16 mb-4 fw-bold">
						{nomePerfil?.name}
					</p>

					<div className="hstack gap-2 justify-content-center mb-0">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								width: 150,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onDeleteClick}
						>
							Inativar
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								width: 150,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

InactivePerfilModal.propTypes = {
	onCloseClick: PropTypes.func,
	onDeleteClick: PropTypes.func,
	show: PropTypes.bool,
	nomePerfil: PropTypes.any,
};

export default InactivePerfilModal;
